module.exports = __webpack_public_path__ + "static/img/bg-wxa-2x.93dd324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/bg-wxa-2x.png
// module id = jJBW
// module chunks = 4